// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"aq-z","slideIn":"bq-z"};